<template>
  <div>
    <header class="header">
      <div class="inner">
        <div class="header-nav">
          <div class="logo-pc" @click="goMain"></div>
          <img src="@/assets/img/newGlobal/introduce/header/menu-open.png" alt="menu" class="open-menu" />
          <div class="pc-nav-wrapper">
            <ul class="pc-nav">
              <li class="pointer" @click="goPage('/Philosophy')">경영철학</li>
              <li class="pointer" @click="goPage('/Culture')">기업문화</li>
              <li class="pointer" @click="goPage('/Ceo')">CEO 메세지</li>
              <li class="pointer" @click="goPage('/news-letter')">사보 당근농장</li>
              <li class="pointer" @click="goPage('/Articles')">Articles(연구발표)</li>
              <li class="pointer" @click="goPage('/History')">회사연혁</li>
              <li class="pointer" @click="goPage('/News')">보도자료</li>
              <li class="pointer" @click="goPage('/Recruit')">인재채용</li>
            </ul>
          </div>
          <!-- <div class="empty"></div> -->
        </div>
        <div class="mt-nav">
          <div class="content-wrapper">
            <div class="icon-wrapper">
              <div @click="goMain">
                <img src="@/assets/img/newGlobal/introduce/header/logo-mt.png" alt="logo" class="logo" />
              </div>
              <img src="@/assets/img/newGlobal/introduce/header/menu-close.png" alt="close" class="close-menu" />
            </div>
            <ul class="main-menu">
              <li class="pointer" @click="goPage('/Philosophy')">경영철학</li>
              <li class="pointer" @click="goPage('/Culture')">기업문화</li>
              <li class="pointer" @click="goPage('/Ceo')">CEO 메세지</li>
              <li class="pointer" @click="goPage('/news-letter')">사보 당근농장</li>
              <li class="pointer" @click="goPage('/Articles')">Articles(연구발표)</li>
              <li class="pointer" @click="goPage('/History')">회사연혁</li>
              <li class="pointer" @click="goPage('/News')">보도자료</li>
              <li class="pointer" @click="goPage('/Recruit')">인재채용</li>
            </ul>
            <ul class="sub-menu">
              <li class="pointer" @click="goPage('/')">CARROT HUB</li>
              <li class="pointer" @click="goPage('/Global')">기업교육:글로벌 역량</li>
              <li class="pointer" @click="openPage('https://www.carrotenglish.kr/')">전화영어:모바일화상</li>
              <li class="pointer" @click="goPage('https://www.imooc.co.kr/')">i:MOOC:신개념 이러닝</li>
              <li class="pointer" @click="goPage('https://www.thespac.net/new/')">SPAC:말하기 평가센터</li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  data() {
    return {
      site: "",
    };
  },
  mounted() {
    // header mobile nav
    const mtMenu = document.querySelector(".mt-nav");

    const openMenu = document.querySelector(".open-menu");
    openMenu.addEventListener("click", function () {
      mtMenu.style.display = "block";
    });

    const closeMenu = document.querySelector(".close-menu");
    closeMenu.addEventListener("click", function () {
      mtMenu.style.display = "none";
    });

    window.addEventListener("DOMContentLoaded", function () {
      if (screen.width > 1350) {
        mtMenu.style.display = "none";
      }
    });

    window.addEventListener("resize", function () {
      if (screen.width > 1350) {
        mtMenu.style.display = "none";
      }
    });
  },
  methods: {
    goMain() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
    openPage(path) {
      window.open(path, "_blank");
    },
    goPage(path) {
      location.href = path;
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;

  .inner {
    position: relative;
    padding: 20px;

    a,
    li {
      font-size: 15px;
      color: #ffffff;
    }

    .header-nav {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        cursor: pointer;
      }

      .logo-pc {
        width: 200px;
        height: 26px;
        background-image: url("https://kr.object.ncloudstorage.com/newglobal/header/logo-pc2.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        cursor: pointer;
      }

      .open-menu {
        width: 18px;
      }

      .pc-nav-wrapper {
        display: none;
      }

      .empty {
        display: none;
      }
    }

    .mt-nav {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);

      .content-wrapper {
        padding: 20px;
        background-color: #2a2929;

        .icon-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .logo {
            width: 200px;
            height: 26px;
          }

          .close-menu {
            width: 21px;
            height: 21px;
            cursor: pointer;
          }
        }

        .main-menu {
          margin-bottom: 20px;

          li {
            padding: 10px 0;
            border-bottom: 1px solid #5b5757;
          }
        }

        .sub-menu li {
          font-size: 12px;
          color: #706a66;
          padding: 10px 0;
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  header {
    .inner {
      padding: 22px 20px;

      .header-nav {
        max-width: 1300px;
        margin: 0 auto;

        .open-menu {
          display: none;
        }

        .pc-nav-wrapper {
          display: block;

          .pc-nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 0 60px;

            a,
            li {
              font-size: 16px;
            }
          }
        }

        .empty {
          display: block;
          width: 150px;
        }
      }

      .mt-nav {
        display: none;
      }
    }
  }
}
</style>
